module.exports = __webpack_public_path__ + "static/media/firestorelogo.7eea1776.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/firestorelogo.png
// module id = 834
// module chunks = 0